/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_DescriptionInputs */

const es_walkthrough_settings_description = /** @type {(inputs: Walkthrough_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectá fuentes de datos como Google, Microsoft, Dropbox y administrá tus archivos y almacenamiento.`)
};

const en_walkthrough_settings_description = /** @type {(inputs: Walkthrough_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect data sources like Google, Microsoft, Dropbox and manage your files and storage.`)
};

/**
* | output |
* | --- |
* | "Connect data sources like Google, Microsoft, Dropbox and manage your files and storage." |
*
* @param {Walkthrough_Settings_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_description = /** @type {((inputs?: Walkthrough_Settings_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_description(inputs)
	return en_walkthrough_settings_description(inputs)
});
export { walkthrough_settings_description as "walkthrough.settings_description" }